import { Controller } from "@hotwired/stimulus"

// The Add/Edit Note form in the bill review drawer. Shows the fields that only make sense for the
// chosen status and reasons, and clears the ones it hides so a stale value can't be submitted.
export default class extends Controller {
  static values = {
    // Reasons whose edit names a replacement code (BillReviewNote::EDIT_REASONS_WITH_SUGGESTED_CODE).
    codeReasons: { type: Array, default: ["wrong code"] },
    // The reason whose edit carries a corrected quantity.
    quantityReason: { type: String, default: "incorrect quantity" }
  }

  connect() {
    this.status = this.element.querySelector("[name='status']");
    this.checkboxes = this.element.querySelector("#checkboxes");
    this.suggestedCode = this.element.querySelector("[name='suggested_code']");
    this.suggestedCodeError = this.element.querySelector("#suggested-code-error");
    this.suggestedQuantity = this.element.querySelector("[name='suggested_quantity']");
    this.publicNote = this.element.querySelector("[name='public_note']");

    this.onStatusChanged();
  }

  onStatusChanged() {
    const isEdited = this.status.value === "edited";
    this.checkboxes.classList.toggle("hidden", !isEdited);
    this.publicNote.classList.toggle("hidden", !isEdited);
    this.refreshReasonFields();
  }

  onReasonsChanged() {
    this.refreshReasonFields();
  }

  // suggested_code only makes sense when the reviewer says the existing code is wrong, and
  // suggested_quantity only when they say the quantity is. Each input (and the code's inline
  // error slot) shows when status is "edited" AND one of its reasons is checked.
  refreshReasonFields() {
    const isEdited = this.status.value === "edited";
    const showCode = isEdited && this.codeReasonsValue.some(reason => this.isChecked(reason));
    const showQuantity = isEdited && this.isChecked(this.quantityReasonValue);

    this.toggleField(this.suggestedCode, showCode);
    if (this.suggestedCodeError) {
      this.suggestedCodeError.classList.toggle("hidden", !showCode);
    }
    this.toggleField(this.suggestedQuantity, showQuantity);
  }

  isChecked(reason) {
    return [...this.element.querySelectorAll("input[name='edit_reasons[]']")]
      .some(box => box.value === reason && box.checked);
  }

  toggleField(field, shouldShow) {
    if (!field) return;
    field.classList.toggle("hidden", !shouldShow);
    if (!shouldShow) field.value = "";
  }
}
